<div class="prop">
    <span class="prop-data-label">
        <div class="indicator" [ngStyle]="{'background-color': color}"></div>
        {{ label }}
    </span>
    <span class="prop-data-value">{{ value }}</span>
</div>
